'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dProduct19 from "./scala.-Product19.js";
var $p;
/** @constructor */
function $c_T19(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19) {
  this.oq = null;
  this.oB = null;
  this.oC = null;
  this.oD = null;
  this.oE = null;
  this.oF = null;
  this.oG = null;
  this.oH = null;
  this.oI = null;
  this.or = null;
  this.os = null;
  this.ot = null;
  this.ou = null;
  this.ov = null;
  this.ow = null;
  this.ox = null;
  this.oy = null;
  this.oz = null;
  this.oA = null;
  this.oq = _1;
  this.oB = _2;
  this.oC = _3;
  this.oD = _4;
  this.oE = _5;
  this.oF = _6;
  this.oG = _7;
  this.oH = _8;
  this.oI = _9;
  this.or = _10;
  this.os = _11;
  this.ot = _12;
  this.ou = _13;
  this.ov = _14;
  this.ow = _15;
  this.ox = _16;
  this.oy = _17;
  this.oz = _18;
  this.oA = _19;
}
export { $c_T19 as $c_T19 };
$p = $c_T19.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_T19;
/** @constructor */
function $h_T19() {
}
export { $h_T19 as $h_T19 };
$h_T19.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.n = (function() {
  return 19;
});
$p.g = (function(n) {
  return $j_scala$002e$002dProduct19.$f_s_Product19__productElement__I__O(this, n);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, (-1955940499), true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_T19) && (((((((((((((((((($j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oq, x$0.oq) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oB, x$0.oB)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oC, x$0.oC)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oD, x$0.oD)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oE, x$0.oE)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oF, x$0.oF)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oG, x$0.oG)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oH, x$0.oH)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oI, x$0.oI)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.or, x$0.or)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.os, x$0.os)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.ot, x$0.ot)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.ou, x$0.ou)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.ov, x$0.ov)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.ow, x$0.ow)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.ox, x$0.ox)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oy, x$0.oy)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oz, x$0.oz)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oA, x$0.oA))));
});
$p.o = (function() {
  return "Tuple19";
});
$p.b = (function() {
  return (((((((((((((((((((((((((((((((((((((("(" + this.oq) + ",") + this.oB) + ",") + this.oC) + ",") + this.oD) + ",") + this.oE) + ",") + this.oF) + ",") + this.oG) + ",") + this.oH) + ",") + this.oI) + ",") + this.or) + ",") + this.os) + ",") + this.ot) + ",") + this.ou) + ",") + this.ov) + ",") + this.ow) + ",") + this.ox) + ",") + this.oy) + ",") + this.oz) + ",") + this.oA) + ")");
});
function $isArrayOf_T19(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eI)));
}
export { $isArrayOf_T19 as $isArrayOf_T19 };
var $d_T19 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_T19, "scala.Tuple19", ({
  eI: 1,
  b: 1,
  c: 1,
  rR: 1,
  a: 1
}));
export { $d_T19 as $d_T19 };
